import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';
import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { ATTENDANCE_VIOLATION_ROUTE } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, DELETE } = HTTP_METHODS;
const { MONTHLY_VIOLATIONS, MY_WARNINGS, APPLY_LEAVE, BULK_DISMISS, dismissViolation } =
  ATTENDANCE_VIOLATION_ROUTE;

export const attendanceViolationApi = createApi({
  reducerPath: 'attendanceViolationApi',
  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),
  tagTypes: ['AttendanceViolation', 'MyWarnings'],
  endpoints: (builder) => ({
    getMonthlyViolations: builder.query({
      query: (data) => ({
        url: `${MONTHLY_VIOLATIONS}${buildQueryString(data)}`,
        method: GET
      }),
      providesTags: ['AttendanceViolation']
    }),
    getMyWarnings: builder.query({
      query: (data) => ({
        url: `${MY_WARNINGS}${buildQueryString(data)}`,
        method: GET
      }),
      providesTags: ['MyWarnings']
    }),
    dismissViolation: builder.mutation({
      query: (violationId) => ({
        url: dismissViolation(violationId),
        method: DELETE
      }),
      invalidatesTags: ['AttendanceViolation', 'MyWarnings']
    }),
    bulkDismissViolations: builder.mutation({
      query: (violationIds) => ({
        url: BULK_DISMISS,
        method: POST,
        data: { violationIds }
      }),
      invalidatesTags: ['AttendanceViolation', 'MyWarnings']
    }),
    applyViolationLeave: builder.mutation({
      query: (data) => ({
        url: APPLY_LEAVE,
        method: POST,
        data
      }),
      invalidatesTags: ['AttendanceViolation', 'MyWarnings']
    })
  })
});

export const {
  useGetMonthlyViolationsQuery,
  useGetMyWarningsQuery,
  useDismissViolationMutation,
  useBulkDismissViolationsMutation,
  useApplyViolationLeaveMutation
} = attendanceViolationApi;
